import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { SuperAdminSidebar } from '../../components/Sidebar';
import api from '../../utils/api';

const STATUS_BADGE = {
  pending:       { cls: 'badge-orange', label: 'Ausstehend' },
  info_required: { cls: 'badge-blue',   label: 'Info erforderlich' },
  trial_active:  { cls: 'badge-green',  label: 'Testphase aktiv' },
  trial_expired: { cls: 'badge-orange', label: 'Test abgelaufen' },
  active:        { cls: 'badge-green',  label: 'Aktiv' },
  expired:       { cls: 'badge-red',    label: 'Abgelaufen' },
  blocked:       { cls: 'badge-red',    label: 'Gesperrt' },
};

const PLAN_BADGE = {
  free: { cls: 'badge-gray', label: 'Kostenlos' },
  standard: { cls: 'badge-blue', label: 'Standard' },
  premium: { cls: 'badge-gold', label: 'Premium' },
};

export default function SuperAdminMosques() {
  const [data, setData] = useState({ mosques: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ status: '', page: 1 });

  const load = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filter.status) params.set('status', filter.status);
    params.set('page', filter.page);
    api.get(`/superadmin/mosques?${params}`).then(r => setData(r.data)).finally(() => setLoading(false));
  }, [filter]);

  const deleteMosque = async (m) => {
    if (!window.confirm(`Moschee "${m.name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`)) return;
    try {
      await api.delete(`/superadmin/mosques/${m.id}`);
      load();
    } catch (err) {
      alert(err.response?.data?.error || 'Fehler beim Löschen');
    }
  };

  useEffect(() => { load(); }, [load]);

  const STATUSES = ['', 'pending', 'trial_active', 'active', 'expired', 'blocked'];

  return (
    <div style={{ display: 'flex' }}>
      <SuperAdminSidebar />
      <main className="main-content">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 style={{ fontSize: 28 }}>Moscheen</h1>
            <p style={{ color: 'var(--text3)' }}>{data.total} registrierte Moscheen</p>
          </div>
          <Link to="/superadmin/mosques/new" className="btn btn-primary">Moschee hinzufügen</Link>
        </div>

        {/* Filter tabs */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {STATUSES.map(s => (
            <button key={s || 'all'} onClick={() => setFilter({ status: s, page: 1 })}
              className={`btn btn-sm ${filter.status === s ? 'btn-primary' : 'btn-ghost'}`}>
              {s ? (STATUS_BADGE[s]?.label || s) : 'Alle'}
            </button>
          ))}
        </div>

        <div className="card">
          {loading ? <div className="spinner-wrap"><div className="spinner" /></div> : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Moschee</th><th>Stadt</th><th>Plan</th><th>Status</th><th>Registriert</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {data.mosques.map(m => {
                    const sb = STATUS_BADGE[m.status] || { cls: 'badge-gray', label: m.status };
                    const pb = PLAN_BADGE[m.plan] || { cls: 'badge-gray', label: m.plan || '—' };
                    return (
                      <tr key={m.id}>
                        <td>
                          <div style={{ fontWeight: 600 }}>{m.name}</div>
                          <div style={{ fontSize: 12, color: 'var(--text3)' }}>{m.login_email}</div>
                        </td>
                        <td style={{ color: 'var(--text2)' }}>
                          {m.city}, {m.country_code}
                          {m.referral_code && (
                            <div style={{ fontSize: 11, fontFamily: 'monospace', color: 'var(--text3)', marginTop: 2 }}>
                              Code: {m.referral_code}
                              {m.referred_by && <span style={{ marginLeft: 6, color: '#8B6A1C' }}>↑ empfohlen</span>}
                            </div>
                          )}
                        </td>
                        <td><span className={`badge ${pb.cls}`}>{pb.label}</span></td>
                        <td><span className={`badge ${sb.cls}`}>{sb.label}</span></td>
                        <td style={{ color: 'var(--text3)', fontSize: 13 }}>{new Date(m.created_at).toLocaleDateString('de-CH')}</td>
                        <td>
                          <div style={{ display: 'flex', gap: 6 }}>
                            <Link to={`/superadmin/mosques/${m.id}`} className="btn btn-sm btn-ghost">Details</Link>
                            <button
                              className="btn btn-sm btn-ghost"
                              style={{ color: 'var(--error)' }}
                              onClick={() => deleteMosque(m)}
                            >
                              Loschen
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
